import { Link } from "react-router-dom";
import { EmptyState } from "../components/AsyncState";

export function NotFoundPage() {
  return <main className="center-page"><EmptyState title="页面不存在" detail="地址可能已失效。" /><Link className="button primary" to="/sessions">返回全部录制</Link></main>;
}
